var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62646 0.527823C4.77678 0.689707 4.76741 0.9428 4.60553 1.09312L1.61863 3.86667H13.9333C14.1543 3.86667 14.3333 4.04576 14.3333 4.26667C14.3333 4.48758 14.1543 4.66667 13.9333 4.66667H1.61863L4.60553 7.44022C4.76741 7.59054 4.77678 7.84363 4.62646 8.00552C4.47614 8.1674 4.22305 8.17677 4.06116 8.02645L0.327832 4.55979C0.246325 4.4841 0.200012 4.3779 0.200012 4.26667C0.200012 4.15544 0.246325 4.04924 0.327832 3.97355L4.06116 0.506886C4.22305 0.356565 4.47614 0.365939 4.62646 0.527823Z",
    fill: "#353F45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "assets/media/back-arrow.0621446f.svg";
export { ForwardRef as ReactComponent };